export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro?: string
  bulletsIntro: string
  bullets: string[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  systemLabel?: string
  system?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Driving Instructor Cueing & Error Correction Handbook',
    subtitle: 'See the mistake. Understand the cause. Give the right correction.',
    intro:
      'A practical instructor reference for identifying problems and correcting them more clearly.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Steering mistakes',
      'Braking errors',
      'Acceleration control',
      'Observation',
      'Mirrors',
      'Positioning',
      'Junction problems',
      'Roundabout mistakes',
      'Parking',
      'Reversing',
      'Hazards',
      'Instructor cueing',
    ],
    systemLabel: 'Core system:',
    system: 'ERROR → CAUSE → CUE → CORRECTION → REPEAT',
    closing: ['Stop saying: “Try again.”', 'Start giving the student a clearer correction.'],
  },
  {
    id: '2',
    title: 'Driving Student Assessment & Progress Tracking System',
    subtitle: 'Know where your student is — and what they should work on next.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Skill assessment',
      'Student profiles',
      'Lesson records',
      'Progress checklists',
      'Independence tracking',
      'Readiness indicators',
      'Next-lesson objectives',
      'Visual rubrics',
      'Student development records',
    ],
    secondaryBulletsIntro: 'Assessment areas include:',
    secondaryBullets: [
      'Control',
      'Observation',
      'Positioning',
      'Junctions',
      'Roundabouts',
      'Parking',
      'Reversing',
      'Hazard awareness',
      'Independence',
    ],
  },
  {
    id: '3',
    title: 'Driving Lesson Planning & Sequencing System',
    subtitle: 'Build better lesson progression without starting from zero.',
    bulletsIntro: 'Includes:',
    bullets: [
      '30-minute lesson structures',
      '45-minute structures',
      '60-minute structures',
      '90-minute structures',
      'Beginner pathways',
      'Developing-driver pathways',
      'Test-ready pathways',
      'Skill sequencing',
      'Lesson progressions',
      'What-to-teach-next decision tools',
    ],
    systemLabel: 'Core flow:',
    system: 'ASSESS → CHOOSE → TEACH → PRACTICE → CHECK → PROGRESS',
  },
  {
    id: '4',
    title: 'Driving Instructor Troubleshooting & Problem-Solving Manual',
    subtitle: 'See the problem. Find the cause. Apply the fix.',
    bulletsIntro: 'A visual diagnostic tool covering problems such as:',
    bullets: [
      'Harsh braking',
      'Late braking',
      'Poor steering',
      'Lane drifting',
      'Weak observation',
      'Hesitation',
      'Rushing',
      'Incorrect positioning',
      'Junction errors',
      'Roundabout confusion',
      'Parking problems',
      'Reversing errors',
      'Hazard-response problems',
    ],
    systemLabel: 'Core system:',
    system: 'PROBLEM → CAUSE → CORRECTION → PRACTICE → RECHECK',
  },
  {
    id: '5',
    title: '100 Driving Practice Challenges, Skill Drills & Student Tasks',
    subtitle: 'Ready-to-use activities for real driving lessons.',
    bulletsIntro: 'Includes activities for:',
    bullets: [
      'Vehicle control',
      'Steering',
      'Braking',
      'Mirrors',
      'Observation',
      'Road positioning',
      'Junctions',
      'Roundabouts',
      'Lane changes',
      'Parking',
      'Reversing',
      'Hazards',
      'Confidence',
      'Precision',
      'Independent driving',
      'Decision-making',
    ],
    closing: [
      'Use them whenever a student needs additional practice without creating another activity yourself.',
    ],
  },
]
